import {
    getApiErrorMessage,
    getFormMode,
    getRecordFromResponse,
    validateSchemaFields
} from 'lib/formUtils';
import {
    Box,
    CardContent,
    TextField,
    Typography
} from '@material-ui/core';
import api from 'services/api';
import PropTypes from 'prop-types';
import { ANAO, ASIM } from 'consts';
import React, { Component } from 'react';
import { AlertInformation } from 'components';
import { safeSetState } from 'lib/reactUtils';
import { FormActions, FormStatusSwitch } from 'views/Components';

class CanalVendaForm extends Component {
    _isMounted = false;
    safeSetState = safeSetState;

    state = {
        isNewRecord: false,
        isView: false,
        canalvenda: {
            codcanal: '',
            desccanal: '',
            inativo: ANAO
        },
        openAlert: false,
        messageAlert: '',
        errors: {},
        schema: {
            desccanal: {
                presence: {
                    allowEmpty: false,
                    message: 'Descrição do canal de venda obrigatória'
                },
                length: { maximum: 100 },
                type: 'string'
            }
        }
    };

    /* Carrega os dados iniciais da tela */
    async componentDidMount() {
        this._isMounted = true;

        const {
            id,
            isNewRecord,
            isView
        } = getFormMode(this.props.match, this.props.location);

        try {
            if (isNewRecord) {
                this.setState({
                    isNewRecord: true,
                    isView: false,
                    canalvenda: this.getCanalVendaDefault()
                });

                return;
            }

            if (!isNaN(Number(id))) {
                await this.loadCanalVenda(id, isView);
            }
        } catch (error) {
            console.error(
                'Erro ao carregar o canal de venda:',
                error.response?.data || error.message
            );

            this.handleOpenAlert(
                getApiErrorMessage(
                    error,
                    'Erro ao carregar o canal de venda!'
                )
            );
        }
    };

    /* Limpa a flag de montagem ao sair da tela */
    componentWillUnmount() {
        this._isMounted = false;
    };

    /* Retorna o canal de venda padrão */
    getCanalVendaDefault = () => ({
        codcanal: '',
        desccanal: '',
        inativo: ANAO
    });

    /* Carrega o canal de venda */
    loadCanalVenda = async (id, isView) => {
        const { history } = this.props;

        const response = await api.get(`/canalvenda/${id}`);
        const registro = getRecordFromResponse(response);

        if (!registro) {
            this.handleOpenAlert('Canal de venda não encontrado!');

            history.push('/crm/canalvenda');

            return;
        }

        this.safeSetState({
            canalvenda: {
                codcanal: registro.codcanal || '',
                desccanal: registro.desccanal || '',
                inativo: registro.inativo || ANAO
            },
            isNewRecord: false,
            isView
        });
    };

    /* Evento onChange componentes */
    onChange = (event) => {
        const { name, type, value, checked } = event.target;

        const adjustedValue = type === 'checkbox' ? (checked ? ANAO : ASIM) : value.toUpperCase();

        this.setState(prevState => ({
            canalvenda: {
                ...prevState.canalvenda,
                [name]: adjustedValue
            }
        }));
    };

    /* Abre a janela de alerta com mensagem */
    handleOpenAlert = (message) => {
        this.safeSetState({
            openAlert: true,
            messageAlert: message
        });
    };

    /* Fecha a janela de mensagem alerta */
    handleCloseAlert = () => {
        this.setState({ openAlert: false });
    };

    /* Retorna o payload de canal de venda */
    getPayloadCanalVenda = () => {
        const { canalvenda } = this.state;

        return {
            desccanal: canalvenda.desccanal || '',
            inativo: canalvenda.inativo || ANAO
        };
    };

    /* Clicar para salvar */
    onClickSave = async () => {
        const { canalvenda, isNewRecord } = this.state;
        const { history, loadCanalVenda } = this.props;

        const errors = this.validationRequiredFields();
        this.setState({ errors });

        if (Object.keys(errors).length > 0) {
            this.handleOpenAlert('Verifique os campos obrigatórios!');

            return;
        }

        try {
            const payload = this.getPayloadCanalVenda();

            if (isNewRecord) {
                await api.post('/canalvenda', payload);
            } else {
                await api.put(`/canalvenda/${canalvenda.codcanal}`, payload);
            }

            if (loadCanalVenda) loadCanalVenda();

            history.push('/crm/canalvenda');
        } catch (error) {
            console.error('Erro ao salvar:', error.response?.data || error.message);

            this.handleOpenAlert(
                getApiErrorMessage(
                    error,
                    'Erro ao salvar!'
                )
            );
        }
    };

    /* Clicar para cancelar */
    onClickCancel = () => {
        this.props.history.push('/crm/canalvenda');
    };

    /* Valida os campos obrigatórios ao salvar */
    validationRequiredFields() {
        const { canalvenda, schema } = this.state;

        return validateSchemaFields(
            canalvenda,
            schema,
            ['desccanal']
        );
    };

    render() {
        const {
            canalvenda,
            errors,
            isView,
            messageAlert,
            openAlert
        } = this.state;

        return (
            <div>
                <CardContent>
                    <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="space-between"
                        style={{ flexWrap: 'wrap' }}
                    >
                        <Typography
                            component="h1"
                            variant="h3"
                        >
                            Canal de venda {canalvenda.codcanal}
                        </Typography>

                        <FormStatusSwitch
                            checked={canalvenda.inativo !== ASIM}
                            name="inativo"
                            onChange={this.onChange}
                            disabled={isView}
                        />
                    </Box>

                    <br />

                    <Box>
                        <TextField
                            label="Descrição"
                            name="desccanal"
                            value={canalvenda.desccanal || ''}
                            variant="outlined"
                            onChange={this.onChange}
                            helperText={errors.desccanal || ''}
                            error={!!errors.desccanal}
                            disabled={isView}
                            inputProps={{ maxLength: 100 }}
                            fullWidth
                        />
                    </Box>

                    <br />
                    <br />

                    <FormActions
                        onSave={this.onClickSave}
                        onCancel={this.onClickCancel}
                        disableSave={isView}
                    />
                </CardContent>

                <AlertInformation
                    open={openAlert}
                    message={messageAlert}
                    handleClose={this.handleCloseAlert}
                />
            </div>
        );
    }
};

CanalVendaForm.propTypes = {
    history: PropTypes.object,
    match: PropTypes.object,
    location: PropTypes.object,
    loadCanalVenda: PropTypes.func
};

export default CanalVendaForm;